var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    strokeWidth: 0,
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.76,59.24H57.24a2,2,0,0,0,2-2V42.76a2,2,0,0,0-2-2H42.76a2,2,0,0,0-2,2V57.24A2,2,0,0,0,42.76,59.24Zm2-14.48H55.24V55.24H44.76ZM80,52a2,2,0,0,0,0-4H72.84V37.83H80a2,2,0,0,0,0-4H72.84V29.16a2,2,0,0,0-2-2H66.17V20a2,2,0,0,0-4,0v7.16H52V20a2,2,0,0,0-4,0v7.16H37.83V20a2,2,0,0,0-4,0v7.16H29.16a2,2,0,0,0-2,2v4.67H20a2,2,0,0,0,0,4h7.16V48H20a2,2,0,0,0,0,4h7.16V62.17H20a2,2,0,0,0,0,4h7.16v4.67a2,2,0,0,0,2,2h4.67V80a2,2,0,0,0,4,0V72.84H48V80a2,2,0,0,0,4,0V72.84H62.17V80a2,2,0,0,0,4,0V72.84h4.67a2,2,0,0,0,2-2V66.17H80a2,2,0,0,0,0-4H72.84V52ZM68.84,68.84H31.16V31.16H68.84Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip);
export default __webpack_public_path__ + "static/media/chip.845f85675f1e60a667464ea600e64f4e.svg";
export { ForwardRef as ReactComponent };